import React from 'react';
import App from 'next/app';

// CPDE-6652: defining getInitialProps opts this app OUT of Next's Automatic
// Static Optimization, forcing per-request SSR. That is required so the CSP
// nonce minted per request in server.js reaches _document via a live ctx.res
// (a statically-exported page has no live req/res). The nonce is what makes
// script-src 'strict-dynamic' work — see server.js cspMiddleware. Mirrors
// webapp's pages/_app.jsx, which defines getInitialProps for the same reason.
export default class MyApp extends App {}

MyApp.getInitialProps = async appContext => {
  const appProps = await App.getInitialProps(appContext);
  return { ...appProps };
};
